var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgXSign = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5972 0.40276C11.0819 -0.11222 10.2467 -0.11222 9.73143 0.40276L6 4.13469L2.26857 0.40276C1.93728 0.0598328 1.4467 -0.0776986 0.985381 0.0430258C0.524058 0.16375 0.163786 0.523943 0.0430353 0.985164C-0.0777157 1.44638 0.059846 1.93686 0.402848 2.26807L4.13428 6L0.402848 9.73193C0.059846 10.0631 -0.0777157 10.5536 0.0430353 11.0148C0.163786 11.4761 0.524058 11.8362 0.985381 11.957C1.4467 12.0777 1.93728 11.9402 2.26857 11.5972L6 7.86531L9.73143 11.5972C10.0627 11.9402 10.5533 12.0777 11.0146 11.957C11.4759 11.8362 11.8362 11.4761 11.957 11.0148C12.0777 10.5536 11.9402 10.0631 11.5972 9.73193L7.86572 6L11.5972 2.26807C12.1122 1.75293 12.1122 0.917896 11.5972 0.40276Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgXSign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/xSign.fc04c61c5682b40e7ed4896e0a8675a8.svg";